import { Component } from '@angular/core';

@Component({
  selector: 'mtm-green-circle-icon',
  templateUrl: './green-circle-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class GreenCircleIconComponent {}
